export default class IllegalStateError extends Error
{

}
